import { SearchSection } from "@/components/UI/CheckboxSelect/components/Search";
import {
  Options,
  AllItem,
} from "@/components/UI/CheckboxSelect/components/Options";
import { Footer } from "@/components/UI/CheckboxSelect/components/Footer";
import { useSearch } from "@/components/UI/CheckboxSelect/hooks";

export const InnerSection = ({
  open,
  boxWidth,
  options,
  optionsName = "measures",
  searchThreshold,
  type,
  withCategory,
  buttonType,
  onDeleteFilter,
  defaultSelected,
  hideApply,
  secondaryButtonText,
  setOpen,
  setSelectedItems,
  applyCallback,
  checkedItems,
  allChecked,
  handleClearAll,
  handleSelectVarious,
  handleCheck,
  handleUncheck,
  initialChecked,
  searchPlaceholder: searchPlaceholderProp,
  allItemLabel: allItemLabelProp,
}: {
  open: boolean;
  boxWidth: string;
  options:
    | Array<{ value: string; label: string }>
    | Array<Record<string, Array<{ value: string; label: string }>>>;
  optionsName: string;
  searchThreshold: number;
  type: "checkbox" | "filter" | "select";
  withCategory: boolean;
  buttonType: "primary" | "secondary";
  onDeleteFilter: () => void;
  defaultSelected: string[];
  hideApply: boolean;
  secondaryButtonText: string;
  setOpen: (isOpen: boolean) => void;
  setSelectedItems: (items: string[]) => void;
  applyCallback: (items: string[]) => void;
  checkedItems: string[];
  allChecked: boolean;
  handleClearAll: () => void;
  handleSelectVarious: (items: string[]) => void;
  handleCheck: (item: string) => void;
  handleUncheck: (item: string) => void;
  initialChecked: string[];
  searchPlaceholder?: string;
  allItemLabel?: string;
}) => {
  const { searchTerm, setSearchTerm } = useSearch(open);

  const allItemLabel = allItemLabelProp || `All ${optionsName}`;
  const searchPlaceholder = searchPlaceholderProp || `Search in ${optionsName}`;

  const handleApply = () => {
    setOpen(false);
    setSelectedItems(checkedItems);
    if (applyCallback) {
      applyCallback(checkedItems);
    }
  };

  const handleSelectAll = () => {
    if (!withCategory) {
      handleSelectVarious(
        (options as Array<{ value: string; label: string }>).map(
          (item) => item.value,
        ),
      );
    } else {
      handleSelectVarious(
        (
          options as Array<
            Record<string, Array<{ value: string; label: string }>>
          >
        ).reduce((acc: string[], item) => {
          const thisName = Object.keys(item)[0];
          const theseItems = item[thisName].map((i) => i.value);
          return [...acc, ...theseItems];
        }, []),
      );
    }
  };

  return (
    <div
      className={`absolute z-50 top-full left-0 w-full bg-white shadow-omni mt-1  overflow-y-auto rounded-[8px] transition-all duration-300 ease-in-out  origin-top  overflow-hidden`}
      style={{
        width: boxWidth,
      }}
    >
      {options?.length > searchThreshold && (
        <SearchSection
          placeholder={searchPlaceholder}
          searchTerm={searchTerm}
          handleSearch={setSearchTerm}
        />
      )}

      <div>
        <div className="max-h-[270px]  overflow-x-clip overflow-y-auto p-2">
          {!type?.includes("filter") && !searchTerm && (
            <AllItem
              placeholder={allItemLabel}
              handleSelectAll={handleSelectAll}
              handleDeselectAll={handleClearAll}
              allChecked={allChecked}
            />
          )}

          <Options
            withCategory={withCategory}
            options={options}
            searchTerm={searchTerm}
            checkedItems={checkedItems}
            handleCheck={handleCheck}
            handleUncheck={handleUncheck}
          />
        </div>
        <Footer
          buttonType={buttonType}
          onDeleteFilter={onDeleteFilter}
          handleClearAll={handleClearAll}
          handleSelectVarious={handleSelectVarious}
          handleApply={handleApply}
          type={type}
          defaultSelected={defaultSelected}
          hideApply={hideApply}
          initialChecked={initialChecked}
          secondaryButtonText={secondaryButtonText}
        />
      </div>
    </div>
  );
};
